import BGI from '../../assets/about-us/new-about-bg.jpg'
import SMAboutCredit from '../../containers/AboutUs/AboutCredit'
import SMVissionAndMission from '../../containers/AboutUs/VissionAndMission'
import SMOurExtensive from '../../containers/AboutUs/OurExtensive'
import SMSalesStatistics from '../../containers/AboutUs/SalesStatistics'
import SMMotorLoanIntroduction from '../../containers/AboutUs/MotorLoanIntroduction'
import SMHomeContactUs from '../../containers/Home/ContactUs'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const AboutUsScreen: React.FC = () => {

    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <>
            <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BGI})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'center',
                width: '100%',
                height: '457px',
            }}>
                <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.25)', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Typography fontSize={50} fontWeight={600} color={'#FBBF23'} textAlign={'center'}>
                        {t('t96')}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '16px' }}>
                        <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t97')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '20px', marginRight: '20px' }}></Box>
                        <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t96')}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <SMAboutCredit />
            <SMVissionAndMission />
            <SMOurExtensive />
            <SMSalesStatistics />
            <SMMotorLoanIntroduction />
            <SMHomeContactUs />
        </>
    )
}

// ======================= EXPORT
export default AboutUsScreen
